import React from 'react';
import './NotFound.css';
import {CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Button from "@mui/material/Button";

/**
 * `loading` (optionnel, défaut false) : pendant une suppression asynchrone,
 * spinner sur « Supprimer », boutons désactivés et fermeture bloquée —
 * le parent passe le `isLoading` de sa mutation.
 */
function ModalDelete({label, onClose, open, selectedValue, onDelete, objectToDelete, loading = false, ...props}) {

    return (
        <Dialog
            open={open}
            onClose={loading ? undefined : onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                Confirmer la suppression
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {label} <b>{objectToDelete}</b>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={"error"} variant={"contained"} disabled={loading}>Annuler</Button>
                <Button onClick={onDelete} color={"success"} variant={"contained"} disabled={loading}
                        startIcon={loading ? <CircularProgress size={18} color="inherit"/> : null}>
                    Supprimer
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ModalDelete;
